module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "AB ParaOverride-1"
  }, [_vm._v("Meet Penny Watson, a passionate teacher, and an Early Years Consultant with over twenty years of hands-on experience with children and advising early years practitioners. When she crafts her picture books, she taps into her wealth of knowledge gained from countless story times with children. She knows exactly what captures their attention, brings a smile to their faces, and prompts those magical words, ‘Read it again, please!’")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Her latest book goes the extra mile by ensuring that children from South Asian Indian backgrounds see themselves or familiar images reflected within its pages. Why? Because every child deserves to see themselves represented in the stories they read – it’s key to understanding their world and feeling valued.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But it’s not just about reflecting one culture; it’s about opening windows to different worlds. Penny understands the importance of children from all backgrounds peeking into each other’s lives. It fosters empathy, curiosity, and a deeper appreciation for the diverse tapestry of our world.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Images _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © Penny Watson 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Illustrated by Penny Weber")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The right of ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Penny Watson ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(" Penny Weber")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" to be identified as author and illustrator of this work has been asserted by them in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ISBN 9781035874408 (Paperback)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ISBN 9781035874415 (ePub e-book)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("www.austinmacauley.com")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("First Published 2024")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Austin Macauley Publishers Ltd®")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("1 Canada Square")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Canary Wharf ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("London")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt5.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt6.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt7.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt9.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt10.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt11.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt12.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt13.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt14.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("We are at the seaside. What can you see?")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I see treasure. What could it be?")])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt16.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt17.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt18.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt19.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt20.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt21.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt22.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt23.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt24.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt25.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt26.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt27.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt28.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt29.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt30.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt31.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt32.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt33.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt34.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt35.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt36.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt37.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt38.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035874408_txt39.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "the-end"
  }, [_vm._v("THE END")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22040248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled-2.vue
// module id = 57
// module chunks = 0